import { motion } from "framer-motion";
import { Linkedin } from "lucide-react";
import SectionHead from "@/components/SectionHead";
import { team } from "@/data/content";

const MemberCard = ({ m, i }) => (
  <motion.div
    data-testid={`team-member-card-${m.id}`}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
    className="group"
  >
    <div className="relative overflow-hidden rounded-xl border border-white/10 aspect-[3/4] bg-elevated">
      <img
        src={m.photo}
        alt={m.name}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-[1.04]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-transparent to-turq/0 transition-colors duration-700 group-hover:to-turq/15" />
      <div className="absolute bottom-0 left-0 right-0 p-5 flex items-end justify-between">
        <div>
          <p className="font-syne text-lg sm:text-xl font-bold text-slate-100">{m.name}</p>
          <p className="mt-1 text-xs uppercase tracking-[0.2em] text-turq">{m.role}</p>
        </div>
        <span className="text-slate-400 group-hover:text-glow transition-colors">
          <Linkedin size={18} />
        </span>
      </div>
    </div>
  </motion.div>
);

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="relative py-28 sm:py-36 bg-navy/30">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead eyebrow="Team" title={<>İçeriğin Arkasındaki <span className="text-gradient">Ekip</span></>} testId="team-title" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl">
          {team.map((m, i) => (
            <MemberCard key={m.id} m={m} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
